import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Container, Placeholder, Row, Col, Card, Button } from 'react-bootstrap';
import { dynamicUrl } from './Function';
const AlumniAll = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';    
    return (
        <section style={{ backgroundImage: `url(${global.config.uploadPath + '575342214.jpg'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
            <Container className="p-5 text-center">
                <h3>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</h3>
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 justify-content-center">
                    <Col>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <div className='border border-white border-dashed rounded p-3'>
                                    <div className="number-circle mt-1 mb-3">
                                        <span className="number">6<sup>th</sup></span>
                                    </div>
                                    <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</Card.Title>
                                    <DynamicLink spId={347} />
                                </div>
                            </Card.Body>                                        
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <div className='border border-white border-dashed rounded p-3'>
                                    <div className="number-circle mt-1 mb-3">
                                        <span className="number">5<sup>th</sup></span>
                                    </div>
                                    <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</Card.Title>
                                    <DynamicLink spId={368} />
                                </div>
                            </Card.Body>                                        
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <div className='border border-white border-dashed rounded p-3'>
                                    <div className="number-circle mt-1 mb-3">
                                        <span className="number">4<sup>th</sup></span>
                                    </div>
                                    <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</Card.Title>
                                    <DynamicLink spId={259} />                                                
                                </div>
                            </Card.Body>                                        
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <div className='border border-white border-dashed rounded p-3'>
                                    <div className="number-circle mt-1 mb-3">
                                        <span className="number">3<sup>rd</sup></span>
                                    </div>
                                    <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</Card.Title>
                                    <DynamicLink spId={320} />                                               
                                </div>
                            </Card.Body>                                        
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <div className='border border-white border-dashed rounded p-3'>
                                    <div className="number-circle mt-1 mb-3">
                                        <span className="number">2<sup>nd</sup></span>
                                    </div>
                                    <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</Card.Title>                                               
                                </div>
                            </Card.Body>                                        
                        </Card>
                    </Col>
                    <Col>
                        <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                            <Card.Body>
                                <div className='border border-white border-dashed rounded p-3'>
                                    <div className="number-circle mt-1 mb-3">
                                        <span className="number">1<sup>st</sup></span>
                                    </div>
                                    <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'पूर्व छात्र सम्मेलन' : 'Alumni Meet'}</Card.Title>                                               
                                </div>
                            </Card.Body>                                        
                        </Card>
                    </Col>                                
                </Row>              
            </Container>
        </section>
    );
};
export default AlumniAll;
const DynamicLink = ({spId}) => 
{
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Links,setLinks]=useState([]);
    useEffect(()=>
    {
        const getDynamicLink = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/MenuById/"+spId);
                const result = await response.json();
                setLinks(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('DynamicLink : Result',result); }
            
            } catch (error) 
            {
                console.error('DynamicLink : Error', error.message);
            }
        };
        getDynamicLink();    
    },[spId])
    return (
        <React.Fragment>
            {isLoading ? (
                <Button variant='info' className='w-50'><Placeholder xs={12} className="rounded" /></Button>
            ) : (
            <React.Fragment>
            {Links.map((sp,index)=>(
                <NavLink className="btn btn-info" to={dynamicUrl(sp)} key={index}>
                    {t('ReadMore')}
                </NavLink>
            ))}
            </React.Fragment>
            )}
        </React.Fragment>
    );
}